module.exports = __webpack_public_path__ + "static/media/background.12affe4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/tennis/media/background.jpg
// module id = 877
// module chunks = 0